import { capitalize } from 'utils/stringUtils';

import PeriodPicker from './PeriodPicker';
import type {
  ExcludableDateRelation,
  UnitOnlyRelationFilterValue,
} from './types';
import { TimeUnitSingular } from './types';

const PERIOD_OPTIONS_CURRENT = Object.values(TimeUnitSingular).map(
  (period) => ({
    value: period,
    label: capitalize(period),
  }),
);

type UnitOnlyInputProps<ExcludedRelations extends ExcludableDateRelation> = {
  relationFilterValue: UnitOnlyRelationFilterValue<ExcludedRelations>;
  onChange: (newUnit: TimeUnitSingular) => void;
  isPopoverOverlayEnabled?: boolean;
};

const UnitOnlyInput = <ExcludedRelations extends ExcludableDateRelation>({
  relationFilterValue,
  onChange,
  isPopoverOverlayEnabled = false,
}: UnitOnlyInputProps<ExcludedRelations>) => {
  return (
    <PeriodPicker
      isPopoverOverlayEnabled={isPopoverOverlayEnabled}
      value={PERIOD_OPTIONS_CURRENT.find(
        (option) => option.value === relationFilterValue.unit,
      )}
      onChange={(selectedOption: (typeof PERIOD_OPTIONS_CURRENT)[number]) => {
        const { value: newUnit } = selectedOption;

        onChange(newUnit);
      }}
      options={PERIOD_OPTIONS_CURRENT}
    />
  );
};

export default UnitOnlyInput;
